import React from 'react';
import { withTariffContext } from 'components/tariffs/TariffContext';
import ProceduresView from 'components/procedures/ProceduresView';
import TariffTypesView from 'components/tariffs/TariffTypesView';
import TariffTaxPointView from 'components/tariffs/TariffTaxPointView';
import ProcedureSelectionView from 'components/procedures/ProcedureSelectionView';
import { SectionPage } from 'components/section/SectionPage';
import SectionContainer from 'components/section/SectionContainer';
import TarmedProcedureView from 'components/procedures/TarmedProcedureView';
import ProcedureGroupsView from 'components/procedures/ProcedureGroupsView';
import LabImportView from 'components/tariffs/LabImportView';

const TariffHome = () => {
  const pages: SectionPage[] = [
    {id: "tariff", uri: "/tariff", component: TariffTypesView},
    {id: "procedures", uri: "/tariff/procedures", component: ProceduresView},
    {id: "proceduresSelection", uri: "/tariff/procedures-selection", component: ProcedureSelectionView},
    {id: "tarmedProcedures", uri: "/tariff/tarmed-procedures", component: TarmedProcedureView},
    {id: "procedureGroups", uri: "/tariff/procedure-groups", component: ProcedureGroupsView},
    {id: "tariffTaxPoint", uri: "/tariff/tariff-tax-point", component: TariffTaxPointView},
    {id: "labImport", uri: "/tariff/lab-import", component: LabImportView}
  ];
  return (
      <SectionContainer sectionPages={pages}/>
  );
};

export default withTariffContext(TariffHome);
